import { ExperimentalOutlinedCardGroup, ExperimentalSectionHeading, Stacked } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { homeQuickStartAtom } from '@/atoms/home/quickStart';
import { CompetitionCard } from './CompetitionCard';
import { DefaultTeamCard } from './DefaultTeamCard';
import { NextOpponentCard } from './NextOpponentCard';
import { PlayerScoutCard } from './PlayerScoutCard';

// Cards without data are left out here rather than rendering nothing, because the card group wraps every element
// it is given in a grid cell, so an empty card would still leave a blank cell behind.
export const QuickStart = () => {
  const { t } = useTranslation('home');
  const { defaultTeam, competition, nextGame, savedSearch } = useAtomValue(homeQuickStartAtom);

  return (
    <Stacked direction="column" gap="small">
      <ExperimentalSectionHeading>{t('quickStart.title')}</ExperimentalSectionHeading>
      <ExperimentalOutlinedCardGroup ariaLabel={t('quickStart.title')} columns={4}>
        <DefaultTeamCard defaultTeam={defaultTeam} />
        {defaultTeam && competition ? <CompetitionCard competition={competition} teamName={defaultTeam.name} /> : null}
        {nextGame ? <NextOpponentCard nextGame={nextGame} /> : null}
        <PlayerScoutCard savedSearch={savedSearch} />
      </ExperimentalOutlinedCardGroup>
    </Stacked>
  );
};
